var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../../../../js/helpers/ifeq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"SortOrder") : depth0),0,{"name":"ifeq","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":12,"column":9}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"thumbnail-image is_active-img "
    + ((stack1 = __default(require("../../../../js/helpers/ifeq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"IsVideo") : depth0),true,{"name":"ifeq","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":45},"end":{"line":3,"column":97}}})) != null ? stack1 : "")
    + "\"\r\n    data-order=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"SortOrder") : depth0), depth0))
    + "\" data-image-id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"CfImageMobile") : depth0), depth0))
    + "\" data-label=\"thumbnail "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"SortOrder") : depth0), depth0))
    + "\">\r\n    <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"CfImageMobile") : depth0), depth0))
    + "\" class=\"img-fluid product__img-thumb-active\" />\r\n</button>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "thumbnail-image-video";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"thumbnail-image "
    + ((stack1 = __default(require("../../../../js/helpers/ifeq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"IsVideo") : depth0),true,{"name":"ifeq","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":31},"end":{"line":8,"column":83}}})) != null ? stack1 : "")
    + "\" data-order=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"SortOrder") : depth0), depth0))
    + "\"\r\n    data-image-id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"CfImageMobile") : depth0), depth0))
    + "\" data-label=\"thumbnail "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"SortOrder") : depth0), depth0))
    + "\">\r\n    <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"CfImageMobile") : depth0), depth0))
    + "\" class=\"img-fluid\" />\r\n</button>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? lookupProperty(depth0,"Thumbnails") : depth0), depth0),{"name":"Thumbnails","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":13,"column":16}}})) != null ? stack1 : "");
},"useData":true});